import type { IconIdType } from "@/components/ui/Icon";

export const footerSections = [
  {
    key: "services",
    label: "Services",
    links: [
      { label: "Standard Translation Service", href: "/translations" },
      { label: "Certified Translation Service", href: "/certified-translation" },
      { label: "Enterprise Translation Services", href: "/business-translation" },
      { label: "Notarized Translation Service", href: "/notarized-translation" },
      { label: "Urgent Translation Service", href: "/urgent-translation" },
    ],
  },
  {
    key: "solutions",
    label: "Solutions",
    links: [
      { label: "Languages", href: "/languages" },
      { label: "Industries", href: "/industries" },
      { label: "Use cases", href: "/use-cases" },
      { label: "Document types", href: "/documents" },
    ],
  },
  {
    key: "resources",
    label: "Resources",
    links: [
      { label: "Blog", href: "/blog" },
      { label: "FAQ", href: "/faq" },
      { label: "Support", href: "/support" },
      { label: "Cost calculator", href: "/cost-calculator" },
    ],
  },
  {
    key: "company",
    label: "Company",
    links: [
      { label: "About us", href: "/about" },
      { label: "Quality guarantee", href: "/quality-guarantee" },
      { label: "Privacy", href: "/privacy-policy" },
      { label: "Terms", href: "/terms-of-service" },
    ],
  },
];

export const footerLegalLinks = [
  { label: "Cookie Preferences" },
  { label: "Security", href: "/trust" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms-of-service" },
  { label: "Status" },
  { label: "Report Illegal Content", href: "/support" },
];

export const socialLinks = [
  {
    href: "https://www.facebook.com/profile.php?id=100084162655499",
    iconId: "icon-facebook-circle_28" as IconIdType,
    label: "Follow us on Facebook",
    width: 28,
    height: 28,
    className: "w-[28px] h-[28px] md:w-[30px] md:h-[30px]",
  },
  {
    href: "https://www.linkedin.com/company/languex-llc",
    iconId: "icon-linkedin-circle_28" as IconIdType,
    label: "Follow us on LinkedIn",
    alt: "LinkedIn",
    width: 28,
    height: 28,
    className: "w-[28px] h-[28px] md:w-[30px] md:h-[30px]",
  },
];
